import React from 'react';
import { Building2, Trash2 } from 'lucide-react';

const UserTable = ({ users, tenants, isSuperAdmin, effectiveTenantId, canManageRoles, t }) => (
    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }} className="hide-scrollbar">
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
                <thead>
                    <tr style={{ borderBottom: '1px solid var(--border)', background: 'rgba(var(--primary-rgb), 0.02)' }}>
                        <th style={{ padding: '1rem 1.5rem', textAlign: 'left' }}>{t('roles.user')}</th>
                        {!effectiveTenantId && isSuperAdmin && <th style={{ padding: '1rem 1.5rem', textAlign: 'left' }}>Business</th>}
                        <th style={{ padding: '1rem 1.5rem', textAlign: 'left' }}>{t('roles.role')}</th>
                        <th style={{ padding: '1rem 1.5rem', textAlign: 'left' }}>{t('roles.status')}</th>
                        <th style={{ padding: '1rem 1.5rem', textAlign: 'right' }}>{t('common.actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(u => (
                        <tr key={u.id} style={{ borderBottom: '1px solid var(--border)' }}>
                            <td style={{ padding: '1rem 1.5rem' }}>
                                <div style={{ fontWeight: 600 }}>{u.firstName} {u.lastName}</div>
                                <div style={{ fontSize: '0.8125rem', color: 'var(--text-muted)' }}>{u.email}</div>
                            </td>
                            {!effectiveTenantId && isSuperAdmin && (
                                <td style={{ padding: '1rem 1.5rem' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}>
                                        <Building2 size={14} style={{ color: 'var(--primary)' }} />
                                        {tenants[u.tenantId] || 'System Admin'}
                                    </div>
                                </td>
                            )}
                            <td style={{ padding: '1rem 1.5rem' }}>
                                <span style={{ fontSize: '0.75rem', fontWeight: 700, padding: '4px 10px', borderRadius: '20px', background: u.role === 'owner' ? 'rgba(var(--primary-rgb), 0.1)' : 'var(--bg-main)', color: u.role === 'owner' ? 'var(--primary)' : 'var(--text-main)', textTransform: 'uppercase' }}>{u.role}</span>
                            </td>
                            <td style={{ padding: '1rem 1.5rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.875rem' }}>
                                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: u.status === 'active' ? '#10b981' : '#f59e0b' }}></div>
                                    {u.status === 'active' ? t('common.active') : t('roles.invited')}
                                </div>
                            </td>
                            <td style={{ padding: '1rem 1.5rem', textAlign: 'right' }}>
                                {u.role !== 'owner' && canManageRoles && <button style={{ background: 'transparent', color: '#ef4444' }}><Trash2 size={16} /></button>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        <style>{`
            .hide-scrollbar::-webkit-scrollbar { display: none; }
        `}</style>
    </div>
);

export default UserTable;
